module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.controller.hasError, 'has-warning': _vm.controller.hasWarning, 'has-success': _vm.controller.hasSuccess
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.controller.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.flip()
      }
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-square-o fa-stack-2x"
  }), _vm._v(" "), (_vm.controller.value) ? _c('i', {
    staticClass: "fa fa-check fa-stack-1x"
  }) : _vm._e()])]), _vm._v(" "), (_vm.controller.hasWarning || _vm.controller.hasError) ? _c('span', {
    staticClass: "help-block"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-exclamation-circle': _vm.controller.hasError, 'fa-exclamation-triangle': _vm.controller.hasWarning
    }
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.controller.message))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d01c76c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d01c76c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/formcheckbox/formcheckbox.scp.html
// module id = 519
// module chunks = 0